import { Typography, useTheme, useMediaQuery } from "@mui/material";
import { TEXT_HEADING_NAME } from "./types";

interface ResponsiveTextProps {
  text: string;
  mrgnBtm?: string;
  tableHeading?: boolean;
  formHeading?: boolean;
  headingName?: string;
}
export const ResponsiveText = ({ text, tableHeading, formHeading }: ResponsiveTextProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Typography
      sx={{
        fontWeight: 500,
        fontStyle: "normal",
        color: "#7a00cc",
        fontSize: isMobile ? "15px" : "20px",
        margin: tableHeading || formHeading ? "10px" : "0px",
      }}
    >
      {text}
    </Typography>
  );
};
